import React from 'react';

export default function ReducedSpendSection() {
  return (
    <section className="reduced-section">
      <div className="container">
        <div className="corp-title">
          Reduce Spend and Time to Fill
        </div>
        <div className="item-box">
          <div className="item">
            <div className="item__circle">
              <i className="icon icon-consult"></i>
            </div>
            <div className="item__text">
              <div className="item__title">Contingent staff management</div>
              <ul className="item__list">
                <li>
                  <span>Streamlined process to fill open roles</span>
                </li>
                <li>
                  <span>
                    Maintain full control of the entire contractor lifecycle
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <div className="item item-2">
            <div className="item__circle">
              <i className="icon icon-hand"></i>
            </div>
            <div className="item__text">
              <div className="item__title">Worker classification assurance</div>
              <ul className="item__list">
                <li>
                  <span>Outsource employment liability & compliance</span>
                </li>
                <li>
                  <span>
                    Employer of Record that meets the urgency of your day-to-day
                    operations
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <div className="item item-3">
            <div className="item__circle">
              <i className="icon icon-management"></i>
            </div>
            <div className="item__text">
              <div className="item__title">Optimized candidate experience</div>
              <ul className="item__list">
                <li>
                  <span>
                    A benefits model that is inclusive of PTO and generous
                    Health Insurance subsidies.
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
